import React from 'react';
import { Separator } from '@dashboard/components/ui/separator';

const SettingsDivider = () => {
  return <Separator className="my-6" />;
};

export default SettingsDivider;
